import React, { useState } from "react"
import PropTypes from "prop-types"

import CustomerDataStep from "./components/CustomerDataStep"
import Wizard from "components/Wizard"
import WizardStep from "components/Wizard/WizardStep"
import ModernModal from "shared/components/ModernModal"
import EnergyDataStep from "./components/EnergyDataStep"
import AddressDataStep from "./components/AddressDataStep"
import OrderStatus from "../OrderStatus"

function RequestForm({ isOpenForm, onClose, customer }) {
  const initialForm = {
    name: "",
    cpf: "",
    birthDate: "",
    phoneNumber: "",
    email: "",
    fileRG: "",
    customerNumber: "",
    energyDistributor: "",
    accountHolder: "PF",
    issueDateOne: "",
    billOne: "",
    issueDateTwo: "",
    billTwo: "",
    cep: "",
    address: "",
    number: "",
    neighborhood: "",
    city: "",
    complement: "",
    fileEnergy: "",
    holderName: "",
    holderCpf: "",
    holderBirthDate: "",
    holderPhoneNumber: "",
    holderEmail: "",
    isSameDataResponsible: false,
    state: ""
  }

  const [formData, setFormData] = useState(initialForm)

  const handleChangeCloseModal = () => {
    setFormData(initialForm)
    onClose()
  }

  const commonProps = {
    customer,
    formData,
    setFormData,
    handleChangeCloseModal
  }

  return (
    <ModernModal
      isOpen={isOpenForm}
      renderFooter={false}
      onClose={handleChangeCloseModal}
    >
      <Wizard>
        <WizardStep
          key="customer-step"
          component={CustomerDataStep}
          {...commonProps}
          onClose={handleChangeCloseModal}
          initialState={initialForm}
        />
        <WizardStep
          key="energy-step"
          component={EnergyDataStep}
          {...commonProps}
        />
        <WizardStep
          key="address-step"
          component={AddressDataStep}
          {...commonProps}
        />

        <WizardStep
          key="order-received"
          component={OrderStatus}
          title="Tudo certo! Seu pedido foi recebido."
          description="Agora é com a gente! Em breve, nossa equipe, junto com a Gedisa, entrará em contato para finalizar sua adesão e apresentar os detalhes da sua economia personalizada."
          buttonText="Finalizar"
          onClose={handleChangeCloseModal}
        />
      </Wizard>
    </ModernModal>
  )
}
RequestForm.propTypes = {
  isOpenForm: PropTypes.bool,
  onClose: PropTypes.func,
  customer: PropTypes.object
}
export default RequestForm



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/RequestForm/index.js